module.exports = __webpack_public_path__ + "static/media/conductor.0e1682af.jpg";